@if (isCleaningCategory()) {
  <app-happy-helper-banner></app-happy-helper-banner>
}

<div class="scroll-progress-container">
  <div class="scroll-progress-bar" id="scroll-progress-bar"></div>
</div>

@if (tip) {
  <div>
    <div class="tips_details_container" scrollProgress>
      <div class="tips_details_container_center animated fadeIn">
        <div class="tips_details">
          <section class="tips_details_description">
            <div class="hero-section">
              @if (tip.generatedImage && tip.generatedImage.length > 0) {
                <img
                  [ngSrc]="tip.generatedImage[0]"
                  fill
                  priority
                  [alt]="$safeNavigationMigration(tip?.imgAltAttribute)"
                  class="hero-background-img"
                />
              }

              <div class="breadcrumb_container">
                <app-breadcrumb-list
                  [standard_max_width]="true"
                  [partsOfUrl]="partsOfUrl"
                >
                </app-breadcrumb-list>
              </div>
              <div class="hero-sub-section">
                <div class="hero-section-text">
                  <h1 class="title">
                    {{ tip.titleTag || (tip.title | titlecase) }}
                  </h1>
                </div>
              </div>
            </div>

            <div
              class="tips_content content_from_mongo"
              [innerHtml]="tip.content.rich_text || tip.content | safe: 'html'"
            ></div>
            <!-- Youtube iFrame -->
            @if (videoLoaded) {
              <div>
                <h2>{{ tip.content.youtubeVidTitle | titlecase }}</h2>
                <div class="videoWrapper">
                  <iframe
                    width="652"
                    height="420"
                    style="border-radius: 5px"
                    [src]="youTubeVidLink"
                    title="YouTube video player"
                    frameborder="0"
                    allow="
                      accelerometer;
                      autoplay;
                      clipboard-write;
                      encrypted-media;
                      gyroscope;
                      picture-in-picture;
                    "
                    allowfullscreen
                  >
                  </iframe>
                </div>
              </div>
            }

            @if (isCleaningCategory()) {
              <app-happy-helper-usps></app-happy-helper-usps>
            }
          </section>

          @if (tip.relatedTips?.length) {
            <section class="related_tips">
              <div>
                <h2>{{ tip?.related_tips_title }}</h2>
              </div>
              <div>
                <div class="article_container">
                  @for (relatedTip of tip.relatedTips; track $index) {
                    <div class="tip_card">
                      <a [href]="$safeNavigationMigration(relatedTip?.fullUrl)">
                        <div
                          class="img-container tips_placeholder_img_container"
                          [ngClass]="{
                            tips_placeholder_img_container:
                              !relatedTip?.generatedImage,
                          }"
                        >
                          @if (!relatedTip?.generatedImage) {
                            <img
                              class="card-img tips_placeholder_img"
                              ngSrc="/assets/svg/logo-inverted.png"
                              alt="image"
                              height="150"
                              width="150"
                              style="position: relative"
                            />
                          } @else {
                            <img
                              [ngSrc]="
                                $safeNavigationMigration(
                                  relatedTip?.generatedImage
                                )
                              "
                              [height]="150"
                              [width]="350"
                              style="position: relative"
                              [alt]="relatedTip?.title || relatedTip?.titleTag"
                            />
                          }
                        </div>
                        <div class="card_body">
                          <h3 class="tips_header">
                            {{ relatedTip?.title || relatedTip?.titleTag }}
                          </h3>
                        </div>
                      </a>
                    </div>
                  }
                </div>
              </div>
            </section>
          }

          @if (tip?.internal_link) {
            <section class="call_to_action_link">
              <div class="body">
                <div class="left_body">
                  <div class="header">
                    <h2>{{ tip?.internal_link?.section_title }}</h2>
                    <p>{{ tip?.internal_link?.section_sub_title }}</p>
                  </div>
                  <!--                  <img
                    class="mockup_mobile"
                    alt="kvinde med telefon"
                    width="360"
                    height="360"
                    ngSrc="/assets/svg/icons/platform-woman.svg"
                    loading="lazy"
                  />-->
                  <button class="handyhand_button blue_button">
                    <a
                      [href]="
                        $safeNavigationMigration(tip?.internal_link?.slug)
                      "
                      >{{ tip?.internal_link?.button_text }}</a
                    >
                  </button>
                </div>
                <!--                <div class="right_body">
                  <img
                    class="mockup"
                    alt="kvinde med telefon"
                    width="360"
                    height="360"
                    ngSrc="/assets/svg/icons/platform-woman.svg"
                    loading="lazy"
                  />
                </div>-->
              </div>
            </section>
          }
          <!--        @if (tasks.length > 0) {
                    <h2>{{ 'PLACEHOLDERS.SIM_TASKS' | translate }}</h2>
                    <app-task-grid
                      [verticalName]="tip.title! | titlecase"
                      [tasks]="tasks"
                    >
                    </app-task-grid>
                  }

                  <app-tips-user-example
                    [categoryName]="tip.catName!"
                    [tagId]="tip.tagId!"
                  >
                  </app-tips-user-example>-->
        </div>

        <!--   <app-tips-list
       [expandValue]="mainCat"
       [fetchByCatSlug]="mainCat"
       class="tips_list">
      </app-tips-list>-->
      </div>

      <app-lp-footer></app-lp-footer>
    </div>
  </div>
}

@if (youtubeSchema) {
  <div [innerHTML]="youtubeSchema | jsonLd"></div>
}
@if (howToSchema) {
  <div [innerHTML]="howToSchema | jsonLd"></div>
}
